export const SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS = 30 * 60 * 1000;